import { getColor } from 'utils';
import styled from 'styled-components';

export const SelectorsRow = styled('div')`
  position: absolute;
  left: 50%;
  bottom: 1rem;
  transform: translateX(-50%);
  width: 40%;
  z-index: 3;
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 0.75rem;
`;

export const SelectorContainer = styled('div')`
  width: 13rem;
  min-width: 13rem;
  border-radius: 0.25rem;
  background-color: ${props => getColor(props, 'primary')};
`;